/// <amd-module name="TFS/Views/ProjectOverviewPage/Actions/ProjectOverviewPageActionCreator" />
import { ActionsHub } from "TFS/Views/ProjectOverviewPage/Actions/ActionsHub";
import { ProjectOverviewPageData } from "TFS/Views/ProjectOverviewPage/Shared/Models";
import { ProjectOverviewPageDataProviderSource } from "TFS/Views/ProjectOverviewPage/Shared/ProjectOverviewPageDataProviderSource";
import { IVssPageContext } from "VSS/Platform/Context";

export class ProjectOverviewPageActionCreator {
    constructor(
        private _pageContext: IVssPageContext,
        private _actionsHub: ActionsHub,
        private _projectOverviewPageSource?: ProjectOverviewPageDataProviderSource
    ) {}

    public loadProjectOverviewData = (): void => {
        this.projectOverviewPageSource.getProjectOverviewPageData().then(
            (pageData: ProjectOverviewPageData | undefined) => {
                if (pageData) {
                    this._actionsHub.projectOverviewPageLoaded.invoke(pageData);
                } else {
                    this._invokeProjectOverviewPageLoadFailed();
                }
            },
            error => {
                this._invokeProjectOverviewPageLoadFailed();
            }
        );
    };

    private get projectOverviewPageSource(): ProjectOverviewPageDataProviderSource {
        if (!this._projectOverviewPageSource) {
            this._projectOverviewPageSource = new ProjectOverviewPageDataProviderSource(this._pageContext);
        }

        return this._projectOverviewPageSource;
    }

    private _invokeProjectOverviewPageLoadFailed(): void {
        this._actionsHub.projectOverviewPageLoadFailed.invoke(void 0);
    }
}
